var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-auto items-center w-full"},[_c('FileBrowser',{staticClass:"mx-auto mt-10",attrs:{"title":_vm.$t('general.UPLOAD_FILES')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }